// extracted by mini-css-extract-plugin
module.exports = {"associated-metadata-checkbox-field":"associated-metadata-field_associated-metadata-checkbox-field__ptyid","checkbox":"associated-metadata-field_checkbox__JxorC"};